<template>
  <div>
    <div class="mrB20" />
    <div class="comm_view_wrap">
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_USR_TYPE')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-3">
          <sui-code-select
            ref="userTypeCode"
            :selected="COD_TYPE"
            codeId="COD_TODO_USR_TYPE"
            :initialSelectedIndex="0"
          />
        </div>
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_USR_VAL')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-3">
          <sui-text-field
            ref="userValue"
            v-model="userValue"
            maxlength="4000"
            :readonly="userValueEditable"
          />
          <sui-button
            type="button"
            class="comm_btn_InputScr"
            @click="onClickInputScr"
          />
        </div>
        <div
          class="col-xs-1 nodata"
        />
        <div
          class="col-xs-3"
          style="justify-content:flex-end;"
        >
          <sui-button
            type="button"
            name="button"
            class="btn_innerTbl_border"
            @click="onClickAdd"
          >
            {{ $t('MSG_BTN_ADD') }}
          </sui-button>
        </div>
      </div>
    </div>
    <div class="mrB30" />
    <sui-grid
      ref="grid"
      :columns="gridColumns0"
      :dataset="'dsNodeTodoUser'"
      :showDisplayCountControl="false"
      :multiselect="true"
    >
      <div class="comp_spacing" />
      <div class="btn_wrapL">
        <sui-button
          v-permission:delete="pageId"
          type="button"
          class="comm_btn_gridTop"
          @click="onClickRowDelete"
        >
          {{ $t('MSG_BTN_ROW_DEL') }}
        </sui-button>
      </div>
    </sui-grid>
    <div class="comm_btn_wrap">
      <sui-button
        v-permission:update="pageId"
        type="button"
        class="comm_btn_solid"
        @click="onClickSave"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00004_T02', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    nodeId: {
      type: String,
      default: null,
    },
    nodeTodoUid: {
      type: String,
      default: null,
    },
    paramValue: {
      type: Object,
      default: null,
    },
    picValue: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      COD_TYPE: { key: '', label: '' },
      userValue: '',
      callType: '',
      userId: '',
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_USR_TYPE'),
        datafield: 'todoUserTypeName',
      }, {
        text: this.$t('MSG_TXT_USR_VAL'),
        datafield: 'todoUserName',
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'nodeUserUseName',
        width: '60px',
      }, {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'userName',
        width: '200px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1', // "1", "2" - default: "1"
            type: 'link', // 'link', 'sublink' - default: "link"
            datafieldMap: {
              displayLanguageId: 'displayLanguageId',
              loginId: 'loginId',
              knoxId: 'knoxId',
              userName: 'userName',
              userGlobalName: 'userGlobalName',
              departmentName: 'departmentName',
              departmentEnglishName: 'departmentEnglishName',
            },
          }, this.dsNodeTodoUser, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_MDFC_DTM'),
        datafield: 'finalModificationDTM',
        width: '150px',
      }],
    };
  },
  computed: {
    userValueEditable() {
      if (utils.isEqual(this.COD_TYPE.key, 'US')
        || utils.isEqual(this.COD_TYPE.key, 'UG')
        || utils.isEqual(this.COD_TYPE.key, 'RL')
        || utils.isEqual(this.COD_TYPE.key, 'PC')) {
        return true;
      }
      return false;
    },
    userTypeRoleFlag() {
      return utils.isEqual(this.COD_TYPE.key, 'RL');
    },
  },
  watch: {
    nodeId() {
      if (!utils.isEmpty(this.nodeId)) {
        this.setNodeTodoUserData();
        this.userValueReset();
      }
    },
    picValue: {
      deep: true,
      handler() {
        this.onPicPopupCallback();
      },
    },
    paramValue: {
      deep: true,
      handler() {
        this.setParamValue();
      },
    },
    COD_TYPE: {
      deep: true,
      handler() {
        this.userValue = '';
        this.userId = '';
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (!utils.isEmpty(this.nodeId)) {
        this.setNodeTodoUserData();
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     * 노드 사용자 목록 조회
     */
    setNodeTodoUserData() {
      const queryParams = {
        nodeId: this.nodeId,
      };

      http.request(this.pageId, 'DTS_CMR_00035', {
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, ['finalModificationDTM']);
        this.dsNodeTodoUser.submit();
        this.dsNodeTodoUser.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
      });
    },
    /**
     * 저장
     */
    onClickSave() {
      const dataParams = {
        nodeId: this.nodeId,
        nodeTodoUid: this.nodeTodoUid,
      };

      utils.assign(dataParams, this.rowState());

      if (!this.selectedNodeCheck()) return false;

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, 'DTS_CMR_00036', {
          data: dataParams,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));

          this.dsNodeTodoUser.submit();

          this.setNodeTodoUserData();
        });
      });

      return true;
    },
    rowState() {
      const insertNodeTodoUserList = [];
      const updateNodeTodoUserList = [];
      const deleteNodeTodoUserList = [];

      utils.forEach(this.dsNodeTodoUser.rowStateMap, (key, value) => {
        let index = -1;
        switch (key) {
          case 'D':
            index = utils.findIndex(this.dsNodeTodoUser.originalData, o => utils.isEqual(o['dataset-row-id'], value));
            if (index > -1) deleteNodeTodoUserList.push(this.dsNodeTodoUser.originalData[index]);
            break;
          case 'U':
            index = utils.findIndex(this.dsNodeTodoUser.data, o => utils.isEqual(o['dataset-row-id'], value));
            if (index > -1) updateNodeTodoUserList.push(this.dsNodeTodoUser.data[index]);
            break;
          case 'C':
            index = utils.findIndex(this.dsNodeTodoUser.data, o => utils.isEqual(o['dataset-row-id'], value));
            if (index > -1) insertNodeTodoUserList.push(this.dsNodeTodoUser.data[index]);
            break;
          default:
            break;
        }
      });

      return {
        insertNodeTodoUserList,
        updateNodeTodoUserList,
        deleteNodeTodoUserList,
      };
    },
    validationCheck() {
      if (utils.isEmpty(utils.trim(this.userValue))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_USR_VAL')),
          null,
          () => {
            this.$refs.userValue.setFocus();
          });
        return false;
      }

      return true;
    },
    /**
     * 사용자 값 버튼 event
     * 사용자 유형에 따른 팝업 호출
     */
    onClickInputScr() {
      switch (this.COD_TYPE.key) {
        case 'US':
          this.onUserPopup();
          break;
        case 'PC':
          this.onPicPopup();
          break;
        case 'UG':
          this.onUserGroupPopup();
          break;
        case 'RL':
          this.onRolePopup();
          break;
        default:
          this.onParamPopup();
          break;
      }
    },
    /**
     * 추가
     */
    onClickAdd() {
      // 사용자 유형 '사용자','역할','사용자그룹' 사용자 값
      const roleValue = `roleId=${this.userId}`;
      const userValue = utils.isEqual(this.COD_TYPE.key, 'RL') ? roleValue : this.userValue;
      const todoUserIdValue = utils.isEqual(this.COD_TYPE.key, 'US')
                            || utils.isEqual(this.COD_TYPE.key, 'UG') ? this.userId : userValue;
      const defaultRow = [{
        nodeId: this.nodeId,
        nodeTodoUid: this.nodeTodoUid,
        todoUserTypeCode: this.COD_TYPE.key,
        todoUserTypeName: this.COD_TYPE.label,
        todoUserIdValue,
        todoUserName: userValue,
        nodeUserUseName: 'Yes',
        nodeUserUseYn: 'Y',
      }];

      if (!this.validationCheck()) return false;

      this.dsNodeTodoUser.addRows(defaultRow);

      return null;
    },
    /**
     * 행 삭제
     */
    onClickRowDelete() {
      const selectedIndexes = this.dsNodeTodoUser.getSelectedIndexes();
      this.dsNodeTodoUser.deleteRows(selectedIndexes);
    },
    /**
     * 사용자 선택 팝업
     * */
    onUserPopup() {
      utils.openLayerPopup('PGE_CMY_00001', this.onUserPopupCallback, {
        // pageInitialData: { iptUserName: iptUserName, userPopupMode: userPopupMode },
        pageInitialData: { },
        size: 'lg',
      });
    },
    onUserPopupCallback(nodeData) {
      if (!utils.isEmpty(nodeData)) {
        this.userValue = nodeData[0].userName;
        this.userId = nodeData[0].userId;
      }
    },
    /**
     * 담당자 유형 팝업
     * */
    onPicPopup() {
      this.$emit('picPopupCall', 'userParamValue');
    },
    onPicPopupCallback() {
      this.userValue = this.picValue.value;
    },
    /**
     * 역할 팝업
     * */
    onRolePopup() {
      utils.openLayerPopup('PGE_CMA_00002', this.onRolePopupCallback, {
        // pageInitialData: { iptUserName: iptUserName, userPopupMode: userPopupMode },
        pageInitialData: { },
        size: 'lg',
      });
    },
    onRolePopupCallback(nodeData) {
      if (nodeData === null) return false;
      if (!utils.isEmpty(nodeData.roleId) || !utils.isUndefined(nodeData.roleId)) {
        this.userValue = nodeData.roleName;
        this.userId = nodeData.roleId;
      }
      return null;
    },
    /**
     * 파라미터 팝업
     * */
    onParamPopup(type) {
      this.callType = type;
      this.$emit('paramPopupCall', 'userParamValue');
    },
    setParamValue() {
      if (utils.isEqual(this.paramValue.type, 'userParamValue')) {
        this.userValue += this.paramValue.value;
      }
    },
    /**
     * 사용자 값 리셋
     * */
    userValueReset() {
      this.userValue = '';
      this.userId = '';
      this.$refs.userTypeCode.reset();
    },
    selectedNodeCheck() {
      if (utils.isEmpty(utils.trim(this.nodeId))) {
        utils.messageBox('warning', this.$t('MSG_ALT_NODE_NOT_INFO'));
        return false;
      }
      return true;
    },
    /**
     * 사용자 그룹 팝업
     * */
    onUserGroupPopup() {
      utils.openLayerPopup('PGE_CMA_00014', this.onUserGroupPopupCallback, {
        // pageInitialData: { iptUserName: iptUserName, userPopupMode: userPopupMode },
        pageInitialData: { },
        size: 'lg',
      });
    },
    onUserGroupPopupCallback(nodeData) {
      if (utils.size(nodeData) < 1) return false;

      if (!utils.isEmpty(nodeData[0].userGroupId) || !utils.isUndefined(nodeData[0].userGroupId)) {
        this.userValue = nodeData[0].userGroupName;
        this.userId = nodeData[0].userGroupId;
      }
      return null;
    },
  },
  datasets: [{
    id: 'dsNodeTodoUser',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'nodeTodoUserUid', map: 'nodeTodoUserUid' },
      { type: 'string', name: 'nodeId', map: 'nodeId' },
      { type: 'string', name: 'nodeTodoUid', map: 'nodeTodoUid' },
      { type: 'string', name: 'todoUserTypeCode', map: 'todoUserTypeCode' },
      { type: 'string', name: 'todoUserId', map: 'todoUserId' },
      { type: 'string', name: 'todoUserIdValue', map: 'todoUserIdValue' },
      { type: 'string', name: 'nodeUserUseYn', map: 'nodeUserUseYn' },
      { type: 'string', name: 'persons', map: 'persons' },
      { type: 'string', name: 'nodeUserUseName', map: 'nodeUserUseName' },
      { type: 'string', name: 'todoUserTypeName', map: 'todoUserTypeName' },
      { type: 'string', name: 'todoUserName', map: 'todoUserName' },
      { type: 'string', name: 'loginId', map: 'loginId' },
      { type: 'string', name: 'knoxId', map: 'knoxId' },
      { type: 'string', name: 'userName', map: 'userName' },
      { type: 'string', name: 'userGlobalName', map: 'userGlobalName' },
      { type: 'string', name: 'departmentName', map: 'departmentName' },
      { type: 'string', name: 'departmentEnglishName', map: 'departmentEnglishName' },
      { type: 'string', name: 'displayLanguageId', map: 'displayLanguageId' },
      { type: 'string', name: 'finalModificationDTM', map: 'finalModificationDTM' },
    ],
  }],
};
</script>
<style scoped>
</style>
